import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DealerWiseAgentListModel } from 'projects/Administration/src/app/business-entities/agent-efficiency-model';
import { DashboardService } from 'projects/Administration/src/app/business-services/dashboard.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { AgentEfficiencyService } from '../../../../business-services/agent-efficiency.service';
import { AgentsDetailsListComponent } from '../agents-details-list/agents-details-list.component';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-dealer-wise-agent-list',
  templateUrl: './dealer-wise-agent-list.component.html'

})
export class DealerWiseAgentListComponent implements OnInit {
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  isDealerRequired: boolean;
  dealerList: any[] = [];
  selectedDealerId: string;
  selectedDealers: string;
  selectedDate: any[] = [];
  totalCount: number = 0;
  dealerWiseAgentList: DealerWiseAgentListModel[];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private userService: UserDataService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private dashboardService: DashboardService,
    private modalService: NgbModal,
    private agentEfficiencyService: AgentEfficiencyService,
    private translate: TranslateService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,
  ) { }

  ngOnInit() {
    this.userService.currentUser.subscribe((resUser) => {
      resUser && this.GetDealers(resUser.id);
    });
    this.setInitialDate();
    this.dealerWiseAgentList = [];
  }

  setInitialDate() {
    let todayDate = new Date();
    let formattedTodayDate = this.datePipe.transform(todayDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(todayDate);
    this.selectedDate.push(todayDate);
    let formatted= formattedTodayDate + ' - ' + formattedTodayDate;
    this.agentEfficiencyService.dealerWiseAgentListRequest.selectedDate = formatted;
  }

  onRefreshClick() {
    this.dealerWiseAgentList = [];
    this.getDealerWiseAgentList();
  }
  async GetDealers(userId) {
    this.spinner.show();
    this.dealerList = await this.dashboardService.GetDealers(userId);
    
    const defaultDealerId = this.userService.currentUserValue.defaultDealerId;
    if (defaultDealerId && this.dealerList) {
      const defaultDealer = this.dealerList.find(dealer => dealer.dealerId === defaultDealerId);
      if (defaultDealer) {
        this.selectedDealers = defaultDealerId;
        this.selectedDealerId = defaultDealerId;
        this.agentEfficiencyService.dealerWiseAgentListRequest.selectedDealer = defaultDealerId;
        this.getDealerWiseAgentList();
      }
    }
    
    this.spinner.hide();
  }

  async onSearch() {
    if (!this.selectedDealers) {
      this.isDealerRequired = true;
      return;
    }
    this.isDealerRequired = false;
    await this.getDealerWiseAgentList();
  }

  async getDealerWiseAgentList() {
    this.dealerWiseAgentList = [];
    this.spinner.show();
    await this.agentEfficiencyService
      .getDealerWiseAgentList(this.agentEfficiencyService.dealerWiseAgentListRequest)
      .then(
        (response) => {
          this.dealerWiseAgentList.push(...response.responseObject);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          }
          else {
            this.totalCount = this.dealerWiseAgentList.length > 0 ? this.dealerWiseAgentList?.length : 0;
            this.dealerWiseAgentList.forEach(x => {
              x.duration = Utility.toHoursAndMinutesAndSecond(x.totalDuration); //((x?.totalDuration > 0) ? (x?.totalDuration/60) : 0.00).toFixed(2);
              x.appointments = "" + x.appointmentsCreated + " / " + x.appointmentsModified;
              x.customers = "" + x.customersCreated + " / " + x.customersModified;
              x.vehicles = "" + x.vehiclesCreated + " / " + x.vehiclesModified
            })
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  async onDateRangeChanged(event: any) {
    this.selectedDate = (typeof event === 'undefined') ? [] : event;
    let selectedDateFormatted= this.getFormattedDate(this.selectedDate);
    if(selectedDateFormatted == ""){
      this.onDateSelectionCleared();
      return;
    }
    
    // Validate 180 days range
    if (this.selectedDate.length === 2) {
      const startDate = new Date(this.selectedDate[0]);
      const endDate = new Date(this.selectedDate[1]);
      const timeDifference = endDate.getTime() - startDate.getTime();
      const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
      
      if (daysDifference > Number(EnvSetting.CDSSCallSummaryReportDays)) {
        let errorMessage = this.translate.instant("lblMonthDateRange");
        errorMessage = errorMessage.replace('{Day}', EnvSetting.CDSSCallSummaryReportDays);
        this.toaster.error(errorMessage);
        this.setInitialDate();
        return;
      }
    }
    
    this.agentEfficiencyService.dealerWiseAgentListRequest.selectedDate = selectedDateFormatted;
  }

  async onChangeDealer(dealer: string) {
    if (!this.selectedDealers) {
      this.isDealerRequired = true;
      return;
    }
    this.isDealerRequired = false;
    this.agentEfficiencyService.dealerWiseAgentListRequest.selectedDealer = dealer;
  }

  onDateSelectionCleared() {
    let warningmsg = this.translate.instant("lblShowingLastMonthData");
    this.toaster.warning(warningmsg);
    this.setInitialDate();
    this.cdr.detectChanges();
  }

  onView(item, entity) {
    const modalref = this.modalService.open(AgentsDetailsListComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.agentId = item.agentId;
    modalref.componentInstance.agentName = item.agentName;
    modalref.componentInstance.selectedDate = this.agentEfficiencyService.dealerWiseAgentListRequest.selectedDate;
    modalref.componentInstance.entityType = entity
    modalref.result.then((response) => {
      this.onRefreshClick();
    });
  }

  // Export functionality
  public async exportAsXLSX() {
    if (await this.validateExport()) {
      this.spinner.show();
      const excelData = this.mapDataForExport();
      this.spinner.hide();
      this.excelService.exportAsExcelFile(excelData, 'Dealer_Wise_Agent_Report');
    }
  }

  public async exportAsPDF() {
    if (await this.validateExport()) {
      this.spinner.show();
      const pdfData = this.mapDataForExport();
      const doc = new jsPDF('landscape');
      autoTable(doc, {
        head: [this.getHeadersForExport()],
        body: pdfData.map(row => Object.values(row)),
        margin: { top: 3, left: 3, right: 3, bottom: 3 },
        styles: { fontSize: 8, cellPadding: { top: 2, right: 5, bottom: 2, left: 2 } },
        columnStyles: {
          2: { halign: 'right' },
          3: { halign: 'right' },
          4: { halign: 'right' },
          5: { halign: 'right' },
          6: { halign: 'right' },
          7: { halign: 'right' }
        }
      });
      doc.save('Dealer_Wise_Agent_Report.pdf');
      this.spinner.hide();
    }
  }

  private async validateExport(): Promise<boolean> {
    if (!this.selectedDealers) {
      this.isDealerRequired = true;
      return false;
    }
    if (this.dealerWiseAgentList.length === 0) {
      await this.getDealerWiseAgentList();
    }
    if (!this.dealerWiseAgentList || this.dealerWiseAgentList.length === 0) {
      this.toaster.error(this.translate.instant('lblDataNotAvailable'));
      return false;
    }
    return true;
  }

  private mapDataForExport(): any[] {
    return this.dealerWiseAgentList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblAgentName')]: item.agentName,
      [this.translate.instant('lblTotalCallDuration')]: item.duration,
      [this.translate.instant('lblTotalCalls')]: item.totalCalls,
      [this.translate.instant('lblCustomersInteracted')]: item.customersInteracted,
      [this.translate.instant('lblAppointmentsCreatedModified')]: item.appointments,
      [this.translate.instant('lblCustomersCreatedModified')]: item.customers,
      [this.translate.instant('lblVehiclesCreatedModified')]: item.vehicles
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblAgentName'),
      this.translate.instant('lblTotalCallDuration'),
      this.translate.instant('lblTotalCalls'),
      this.translate.instant('lblCustomersInteracted'),
      this.translate.instant('lblAppointmentsCreatedModified'),
      this.translate.instant('lblCustomersCreatedModified'),
      this.translate.instant('lblVehiclesCreatedModified')
    ];
  }
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}